import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function RedirectIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.09835 5.09835C5.80161 4.39509 6.75544 4 7.75 4H16.25C17.2446 4 18.1984 4.39509 18.9017 5.09835C19.6049 5.80161 20 6.75544 20 7.75V16.25C20 17.2446 19.6049 18.1984 18.9017 18.9017C18.1984 19.6049 17.2446 20 16.25 20H7.75C6.75544 20 5.80161 19.6049 5.09835 18.9017C4.39509 18.1984 4 17.2446 4 16.25V7.75C4 6.75544 4.39509 5.80161 5.09835 5.09835ZM7.75 5.5C7.15326 5.5 6.58097 5.73705 6.15901 6.15901C5.73705 6.58097 5.5 7.15326 5.5 7.75V16.25C5.5 16.8467 5.73705 17.419 6.15901 17.841C6.58097 18.2629 7.15326 18.5 7.75 18.5H16.25C16.8467 18.5 17.419 18.2629 17.841 17.841C18.2629 17.419 18.5 16.8467 18.5 16.25V9H10.75C10.2859 9 9.84075 8.81563 9.51256 8.48744C9.18437 8.15925 9 7.71413 9 7.25V5.5H7.75ZM10.5 5.5V7.25C10.5 7.3163 10.5263 7.37989 10.5732 7.42678C10.6201 7.47366 10.6837 7.5 10.75 7.5H13.5V5.5H10.5ZM15 5.5V7.5H18.4861C18.4297 6.99525 18.2036 6.52162 17.841 6.15901C17.419 5.73705 16.8467 5.5 16.25 5.5H15Z"
        fill="#344054"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.09835 5.09835C5.80161 4.39509 6.75544 4 7.75 4H16.25C17.2446 4 18.1984 4.39509 18.9017 5.09835C19.6049 5.80161 20 6.75544 20 7.75V16.25C20 17.2446 19.6049 18.1984 18.9017 18.9017C18.1984 19.6049 17.2446 20 16.25 20H7.75C6.75544 20 5.80161 19.6049 5.09835 18.9017C4.39509 18.1984 4 17.2446 4 16.25V7.75C4 6.75544 4.39509 5.80161 5.09835 5.09835ZM7.75 5.5C7.15326 5.5 6.58097 5.73705 6.15901 6.15901C5.73705 6.58097 5.5 7.15326 5.5 7.75V16.25C5.5 16.8467 5.73705 17.419 6.15901 17.841C6.58097 18.2629 7.15326 18.5 7.75 18.5H16.25C16.8467 18.5 17.419 18.2629 17.841 17.841C18.2629 17.419 18.5 16.8467 18.5 16.25V9H10.75C10.2859 9 9.84075 8.81563 9.51256 8.48744C9.18437 8.15925 9 7.71413 9 7.25V5.5H7.75ZM10.5 5.5V7.25C10.5 7.3163 10.5263 7.37989 10.5732 7.42678C10.6201 7.47366 10.6837 7.5 10.75 7.5H13.5V5.5H10.5ZM15 5.5V7.5H18.4861C18.4297 6.99525 18.2036 6.52162 17.841 6.15901C17.419 5.73705 16.8467 5.5 16.25 5.5H15Z"
        fill="#344054"
      />
    </svg>
  );
};
